import Select from 'react-select';
import { useApp } from '../common/AppProvider';
import { translations } from '../translations/translations';
import type { Action, Trigger } from '../types/types';

type TriggerOrActionOptionType = {
    value: string;
    label: string;
};

const TriggerOrActionPicker = ({
    itemType,
    itemData,
    onChange,
}: {
    itemType: 'trigger' | 'action';
    itemData: Trigger | Action;
    onChange: (selectedTriggerOrAction: Trigger | Action) => void;
}) => {
    const { language, connectors } = useApp();

    const connector = connectors[itemData.providerId];
    const triggersOrActions: Trigger[] | Action[] = connector
        ? Object.values(itemType === 'trigger' ? connector.triggers : connector.actions)
        : [];
    const triggersOrActionsOptions: TriggerOrActionOptionType[] = triggersOrActions.map((toa) => ({
        value: toa.id,
        label: toa.name,
    }));

    return (
        <Select
            className="react-select-container"
            classNamePrefix="react-select"
            placeholder={
                itemType === 'trigger'
                    ? translations[language].TASK_select_trigger
                    : translations[language].TASK_select_action
            }
            options={triggersOrActionsOptions}
            value={itemData.id ? { label: itemData.name, value: itemData.id } : null}
            onChange={(selectedOption) => {
                const { value } = selectedOption!;
                const selectedTriggerOrAction = Object.values(triggersOrActions).find(
                    (toa) => toa.id === value,
                );
                const isAlreadySelected = selectedTriggerOrAction?.id === itemData.id;

                if (selectedTriggerOrAction && !isAlreadySelected) {
                    onChange(selectedTriggerOrAction);
                }
            }}
            isMulti={false}
            isClearable={false}
            menuPlacement="auto"
        />
    );
};

export default TriggerOrActionPicker;
